import Confirmation from './confirmation/ResetPasswordConfirmation';
import Request from './request/ResetPasswordRequest';
import Reset from './reset/ResetPassword';
import RequestAgain from './request-again/ResetPasswordRequestAgain';


export default { RequestAgain, Reset, Request, Confirmation };
